import { graphql } from 'gatsby';
import React, { useState } from 'react';
import Seo from 'gatsby-plugin-wpgraphql-seo';
import Layout from '~/components/Layout';
import HeroResource from '~/components/organisms/HeroResource';
import HeroResourceEmbed from '~/components/organisms/HeroResourceEmbed';
import HeroResourceDownload from '~/components/organisms/HeroResourceDownload';
import Newsletter from '~/components/organisms/Newsletter';
import ResourcesSlider from '~/components/organisms/ResourcesSlider';
import SocialSharing from '~/components/molecules/SocialSharing';
import Text from '~/components/molecules/Text';
import Button from '~/components/atoms/Button';
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import FlexibleContent from '~/components/FlexibleContent';
import CustomSEO from '~/components/seo/CustomSEO';
import { articleLabels } from '~/data/translations/articleLabels';
import { socialSharingLabels } from '~/data/translations/socialSharingLabels';
import FaqItems from '~/components/molecules/FaqItems';
export default function ResourcesArticlePage({ data: { wpPost, allWpPost, pageLanguage = 'en' } }) {
  const { title, content, resourcePostItem, categories, featuredImage, author, day, month, year } = wpPost;
  console.log('wpPost:', wpPost);
  const customSeo = {
    ...wpPost?.seo,
    image: featuredImage?.node,
  }
  const flexibleContent =
    (resourcePostItem?.resourcePostItem?.content || []).filter(
      item =>
        item.fieldGroupName !==
        'post_Resourcepostitem_ResourcePostItem_Content_Faqs'
    );

  // const [expanded, setExpanded] = useState(false);
  const faqs =
    resourcePostItem?.resourcePostItem?.content?.filter(
      item =>
        item.fieldGroupName ===
        'post_Resourcepostitem_ResourcePostItem_Content_Faqs'
    ) || [];

  const section = {
    faqs: faqs, // <-- keep it as ARRAY
  };

  console.log('section for FaqItems:', section);
  const cityCategory = resourcePostItem?.resourcePostItem?.category;
  if (cityCategory == 'paris') {
    pageLanguage = 'fr';
  } else {
    pageLanguage = 'en';
  }
  const relatedPosts =
    (allWpPost && Array.isArray(allWpPost.nodes)
      ? allWpPost.nodes.filter(post => {

        const postCategory =
          post?.resourcePostItem?.resourcePostItem?.city?.trim()?.toLowerCase();
        const targetCategory = cityCategory?.trim()?.toLowerCase();
        return postCategory === targetCategory;
      })
      : []);
  const labels = articleLabels[pageLanguage];
  const sharelabels = socialSharingLabels[pageLanguage];
  console.log('pageLanguage:', pageLanguage);
  return (
    <Layout pageLanguage={pageLanguage}>
      <Seo post={wpPost} />
      <CustomSEO seo={customSeo} />
      {resourcePostItem?.resourcePostItem?.embed ? (
        <HeroResourceEmbed title={title} author={author.node} categories={categories} embed={resourcePostItem.resourcePostItem.embed} />
      ) : (resourcePostItem.resourcePostItem?.download?.image && resourcePostItem.resourcePostItem?.download?.button) ? (
        <HeroResourceDownload title={title} author={author.node} categories={categories} download={resourcePostItem.resourcePostItem.download} />
      ) : (
        <HeroResource title={title} image={featuredImage?.node} author={author.node} categories={categories} />
      )}

      <section id="article-content" className="my-20 md:my-36">
        <div className="container">
          <div className="grid grid-cols-12 relative">
            <div className="col-span-1">
              <div className="hidden lg:flex flex-col items-center space-y-7 sticky top-1/4">
                <div>
                  <time className="text-h2">{day}</time>
                  <div className="text-h6 text-sm">{month} {year}</div>
                </div>
                <div className="border-b border-b-yellow w-full"></div>
                <SocialSharing
                  headingText={sharelabels.headingTextForArticle}
                  headingType="h6"
                  headingClassName="md:!mr-0"
                  className="mt-16 md:flex-col items-center text-center"
                  iconsClassName="flex-col space-y-3 md:space-x-0 mt-4"
                />
              </div>
            </div>
            <FadeInWhenVisible className="col-span-10">
              <Text content={content} />
              <FlexibleContent content={flexibleContent} />
              {section?.faqs?.length > 0 && (
                <div className="container">
                  <div className="max-w-xl mx-auto justify-center mt-8">
                    <h3 className="text-h3 text-center mb-14">FAQs</h3>
                    <FaqItems {...section} />
                  </div>
                </div>
              )}
              {resourcePostItem?.resourcePostItem?.cta && (
                <div className="max-w-xl mx-auto flex justify-center mt-8">
                  <Button {...resourcePostItem?.resourcePostItem?.cta} />
                </div>
              )}
              <div className="max-w-xl mx-auto block border-b border-b-navy border-opacity-10 mt-16"></div>
              <SocialSharing className="mt-16" />
            </FadeInWhenVisible>


          </div>
          <div className="col-span-1"></div>
        </div>
      </section>

      {pageLanguage !== 'fr' && <Newsletter />}
      <ResourcesSlider
        title={labels.title}
        button={[
          {
            title: labels.buttonTitle,
            url: '/resources/',
            target: '',
            pageLanguage: pageLanguage
          },
        ]}
        posts={relatedPosts}
      />
    </Layout>
  );
}

export const pageQuery = graphql`
  query ArticleQuery($id: String!, $resourceType: String!) {
    allWpPost(limit: 12, filter:{id: { ne: $id }, 
      categories: { nodes: { elemMatch: { name:{ nin: [ "Uncategorized", "Uncategorised"] }}}} 
      resourceTypes: { nodes:{ elemMatch:{ slug:{ eq: $resourceType }}}}
      
    }) {
     nodes { ...PostPreview id slug resourcePostItem { resourcePostItem { city: category } } }
    }

    wpPost(id: { eq: $id }) {
      ...BlogSEO
      title
      content
      date
      day: date(formatString:"DD")
      month: date(formatString:"MMM")
      year: date(formatString:"YY")
      resourceTypes {
        nodes {
          name
        }
      }
      resourcePostItem {
        resourcePostItem {
          embed
          category
          download {
            button {
              ... Button
            }
            image {
              ... Image
            }
          }
          cta{
            ... Button
          }
            
          content {
            ... on WpPost_Resourcepostitem_ResourcePostItem_Content_Text {
              text
              fieldGroupName
            }

              ... on WpPost_Resourcepostitem_ResourcePostItem_Content_Faqs {
                question
                answer
                fieldGroupName
              }
            ... on WpPost_Resourcepostitem_ResourcePostItem_Content_Download {
              textCard {
                illustration {
                  ... Image
                }
                subheading
                subheadingColor
                alignText
                heading {
                  text
                  type
                }
                content
                buttons {
                  button {
                    button {
                      button {
                        ... Button
                      }
                    }
                    type
                  }
                }
              }
              fieldGroupName
              image {
                ... Image
              }
            }
          }
        }
      }
      author {
        node {
          firstName
          lastName
        }
      }
      categories {
        nodes {
          name
        }
      }
      featuredImage {
        node {
          ... Image
        }
      }
    }
  }
`;
